<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container-fluid">
  <div *ngFor="let conf of conferences" class="card mb-5">
    <bxl-conference-item [conference]="conf"></bxl-conference-item>
  </div>
</div>
